import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import Layout from "@/components/site/Layout";
import Home from "@/pages/Home";
import WhyPartner from "@/pages/WhyPartner";
import WhoWeServe from "@/pages/WhoWeServe";
import Segment from "@/pages/Segment";
import HowItWorks from "@/pages/HowItWorks";
import Company from "@/pages/Company";
import BecomePartner from "@/pages/BecomePartner";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors offset={80} />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/why-partner" element={<WhyPartner />} />
            <Route path="/who-we-serve" element={<WhoWeServe />} />
            <Route path="/who-we-serve/:slug" element={<Segment />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/company" element={<Company />} />
            <Route path="/become-a-partner" element={<BecomePartner />} />
          </Route>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
